import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("tv_access");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config;
    const refresh = localStorage.getItem("tv_refresh");
    if (error.response?.status === 401 && refresh && !orig._retry) {
      orig._retry = true;
      try {
        refreshing =
          refreshing ||
          axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/refresh`, { refresh_token: refresh });
        const { data } = await refreshing;
        refreshing = null;
        localStorage.setItem("tv_access", data.access_token);
        localStorage.setItem("tv_refresh", data.refresh_token);
        orig.headers.Authorization = `Bearer ${data.access_token}`;
        return api(orig);
      } catch (e) {
        refreshing = null;
        localStorage.removeItem("tv_access");
        localStorage.removeItem("tv_refresh");
      }
    }
    return Promise.reject(error);
  }
);

export default api;
